import { render, staticRenderFns } from "./EnemyStatus.vue?vue&type=template&id=dcfa0f9e&scoped=true"
import script from "./EnemyStatus.vue?vue&type=script&lang=js"
export * from "./EnemyStatus.vue?vue&type=script&lang=js"
import style0 from "./EnemyStatus.vue?vue&type=style&index=0&id=dcfa0f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa0f9e",
  null
  
)

export default component.exports